import GetPrivateData from '../Classes/GetPrivateData.js';
import ResizeObserverFrame from '../Elements/ResizeObserverFrame.js';

class ResizeObserver
{
	constructor(callback)
	{
		getPrivateData.for(this).callback = callback;
	}

	observe(target)
	{
		const privateData = getPrivateData.for(this);
		target.classList.add('s2nResizeObserverTarget');
		const resizeObserverFrame = new ResizeObserverFrame(target);
		resizeObserverFrame.element.contentWindow.addEventListener
		(
			'resize',
			() =>
			{
				privateData.callback.call
				(
					this,
					[
						new ResizeObserverEntry
						(
							resizeObserverFrame.element.getBoundingClientRect(),
							target
						)
					],
					this
				);
			}
		);
		resizeObserverFrame.element.contentWindow.dispatchEvent(new CustomEvent('resize'));
	}
}

export default window.ResizeObserver || ResizeObserver;

const getPrivateData = new GetPrivateData(ResizeObserver);

class ResizeObserverEntry
{
	constructor(contentRect,target)
	{
		contentRect = {x:0,y:0,width:contentRect.width, height:contentRect.height};

		Object.defineProperties
		(
			this,
			{
				contentRect:
				{
					value:contentRect
				},
				target:
				{
					value:target
				}
			}
		);
	}
}